var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("popup", {
        attrs: {
          opened: _vm.openData,
          "use-header": true,
          "use-footer": true,
          "btn-area-padding": true,
          title: "MPAY-02-01-31-01"
        },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticClass: "form" }, [
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("mnrcv-acno", {
                        ref: "mnrcvAcno",
                        attrs: {
                          inAcnKnd: "1",
                          inAcnDtlKnd: "2",
                          value: _vm.account,
                          "obaob-dstcd": "1",
                          page: "transfer"
                        },
                        on: {
                          "update:value": function($event) {
                            _vm.account = $event
                          },
                          selected: _vm.changeAcno,
                          click: _vm.clickAcno
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "item-tit" }, [
                      _vm._v(_vm._s(/*입금금액*/ _vm.$t("MPAY-01-01-10-02")))
                    ]),
                    _c("div", { staticClass: "item-desc" }, [
                      _c("div", { staticClass: "form-multi-group--type2" }, [
                        _c("span", { staticClass: "unit" }, [
                          _vm._v(_vm._s(_vm.amtData.mnrcvCncycd))
                        ]),
                        _c("div", { attrs: { required: "required" } }, [
                          _c("div", { staticClass: "form-text-field" }, [
                            _c("div", { staticClass: "input-text-field" }, [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "mnrcvAmt01",
                                  disabled: ""
                                },
                                domProps: {
                                  value: _vm.$num(_vm.mnrcvAmt01, 0, true)
                                }
                              }),
                              _c("span", { staticClass: "default-number" }, [
                                _c("em", [_vm._v(_vm._s(_vm.mnrcvAmt02))])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm.amtData.mnrcvCncycd != _vm.amtData.drwotCncycd
                    ? _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "item-tit" }, [
                          _vm._v(
                            _vm._s(/*출금금액*/ _vm.$t("MPAY-01-01-09-05"))
                          )
                        ]),
                        _c("div", { staticClass: "item-desc" }, [
                          _c(
                            "div",
                            { staticClass: "form-multi-group--type2" },
                            [
                              _c("span", { staticClass: "unit" }, [
                                _vm._v(_vm._s(_vm.amtData.drwotCncycd))
                              ]),
                              _c("div", { attrs: { required: "required" } }, [
                                _c("div", { staticClass: "form-text-field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "input-text-field" },
                                    [
                                      _c("input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "drwotAmt01",
                                          disabled: ""
                                        },
                                        domProps: {
                                          value: _vm.$num(
                                            _vm.drwotAmt01,
                                            0,
                                            true
                                          )
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "default-number" },
                                        [
                                          _c("em", [
                                            _vm._v(_vm._s(_vm.drwotAmt02))
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "btn-area" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn lg inline",
                          on: { click: _vm.onMnrcvAmt }
                        },
                        [
                          _vm._v(
                            _vm._s(/*금액변경*/ _vm.$t("MPAY-01-01-10-03"))
                          )
                        ]
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("input-text", {
                        ref: "drwotRmark",
                        attrs: {
                          id: "drwotRmark",
                          value: _vm.mnrcvTmp.drwotRmark,
                          labelI18n:
                            "" +
                            (_vm.siteCode == _vm.$config.SITECODE_OGMMR
                              ? /*송금메모(송금목적)*/ "MPAY-01-01-11-12"
                              : /*송금메모*/ "MPAY-01-01-11-05"),
                          placeholder: "MPAY-01-01-11-06",
                          localeNum:
                            _vm.$config.SITECODE_OGMMR +
                            "|" +
                            _vm.$config.SITECODE_OGCBD,
                          alphaLocaleOnly3: "" + _vm.$config.SITECODE_OGHCM,
                          alphaNum:
                            _vm.$config.SITECODE_OGIND +
                            "|" +
                            _vm.$config.SITECODE_OGAUC,
                          maxByte:
                            _vm.$config.SITECODE_OGMMR +
                            "=48|" +
                            _vm.$config.SITECODE_OGCBD +
                            "=48|" +
                            _vm.$config.SITECODE_OGHCM +
                            "=60|" +
                            _vm.$config.SITECODE_OGIND +
                            "=48|" +
                            _vm.$config.SITECODE_OGAUC +
                            "=48"
                        },
                        on: {
                          "update:value": function($event) {
                            return _vm.$set(_vm.mnrcvTmp, "drwotRmark", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("input-text", {
                        ref: "mnrcvRmark",
                        attrs: {
                          id: "mnrcvRmark",
                          value: _vm.mnrcvTmp.mnrcvRmark,
                          labelI18n: "MPAY-01-01-11-07",
                          placeholder: "MPAY-01-01-10-12",
                          localeNum:
                            _vm.$config.SITECODE_OGMMR +
                            "|" +
                            _vm.$config.SITECODE_OGCBD,
                          alphaLocaleOnly3: "" + _vm.$config.SITECODE_OGHCM,
                          alphaNum:
                            _vm.$config.SITECODE_OGIND +
                            "|" +
                            _vm.$config.SITECODE_OGAUC,
                          maxByte:
                            _vm.$config.SITECODE_OGMMR +
                            "=48|" +
                            _vm.$config.SITECODE_OGCBD +
                            "=48|" +
                            _vm.$config.SITECODE_OGHCM +
                            "=60|" +
                            _vm.$config.SITECODE_OGIND +
                            "=48|" +
                            _vm.$config.SITECODE_OGAUC +
                            "=48"
                        },
                        on: {
                          "update:value": function($event) {
                            return _vm.$set(_vm.mnrcvTmp, "mnrcvRmark", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCfmBtn,
                        expression: "showCfmBtn"
                      }
                    ],
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onUpdateCfm($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MCOM-0000003")))]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("mnrcv-trsacc-amt", {
        ref: "mnrcvTrasccAmt",
        attrs: {
          opened: _vm.openedMnrcvAmt,
          "acno-info": _vm.acno,
          info: _vm.amtData,
          page: "transfer"
        },
        on: {
          "update:opened": function($event) {
            _vm.openedMnrcvAmt = $event
          },
          "update:info": function($event) {
            _vm.amtData = $event
          }
        }
      }),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: { opened: _vm.openedError, confirm: "MCOM-0000003" },
        on: {
          "update:opened": function($event) {
            _vm.openedError = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _vm._v(
                  _vm._s(
                    _vm.minAmt >= 0
                      ? _vm.$t(_vm.errMsg, { min: _vm.minAmt })
                      : _vm.$t(_vm.errMsg)
                  )
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }